import { z } from 'zod';

import { BaseLoanEvent } from './BaseLoanEvent';

export const MailMonthlyStatementTaskEvent = BaseLoanEvent.extend({
  type: z.literal('mailMonthlyStatementTask'),
});
export type MailMonthlyStatementTaskEvent = z.infer<typeof MailMonthlyStatementTaskEvent>;
